// src/mixins/reCaptchaMixin.js

export default {
    methods: {
        loadRecaptcha() {
            return new Promise((resolve, reject) => {
                if (window.grecaptcha) {
                    resolve(window.grecaptcha);
                } else {
                    const script = document.createElement('script');
                    script.src = `https://www.google.com/recaptcha/api.js?render=${this.$recaptchaSiteKey}`;
                    script.async = true;
                    script.onload = () => {
                        if (window.grecaptcha) {
                            resolve(window.grecaptcha);
                        } else {
                            reject('reCAPTCHA failed to load');
                        }
                    };
                    script.onerror = () => reject('reCAPTCHA script failed to load');
                    document.head.appendChild(script);
                }
            });
        },
        executeRecaptcha(action) {
            return this.loadRecaptcha().then(grecaptcha =>
                grecaptcha.execute(this.$recaptchaSiteKey, { action })
            );
        }
    },
    data() {
        return {
            recaptchaToken: ''
        };
    },
    created() {
        this.$recaptchaSiteKey = process.env.VUE_APP_RECAPTCHA_SECRET;
    },
    beforeCreate() {
        if(process.env.VUE_APP_ACTIVATE_RECAPTCHA == 'true' || process.env.VUE_APP_ACTIVATE_RECAPTCHA == true){
            var script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?render=' + process.env.VUE_APP_RECAPTCHA_SECRET;
            document.body.appendChild(script);
        }
    }
};
